import { Button, Dialog, DialogTitle, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import MainBrandTable from "./MainBrandTable";

interface Props {
  open: boolean;
  handleClose: () => void;
  familyName: string;
  interfaceName: string;
  rows: { brand_id: number | string; brand_name: string; status: boolean }[];
}

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  status: "Status",
};

const MainBrandModal = ({
  open,
  handleClose,
  familyName,
  interfaceName,
  rows,
}: Props) => {
  return (
    <>
      <Dialog
        open={open}
        PaperProps={{ sx: { width: "450px", maxWidth: "450px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 10px 0px" }}>
            {familyName}
          </DialogTitle>
          <Typography variant="body2">
            {interfaceName} - {rows.length} Brands
          </Typography>

          <MainBrandTable tableHeadings={tableHeadings} rows={rows} />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              Close
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default MainBrandModal;
